import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'

import { Title } from '@/modules/base/components/texts'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'

import OMOLogo from 'assets/images/logo/svg/logo-plain.svg'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    width: '100%',
    padding: '0px 30px',
    flex: '1',
    justifyContent: 'space-between',
    '& a': {
      color: theme.auth.link.color,
    },

    [theme.devices.mobile]: {
      padding: 0,
    },
  },
  headerContainer: {
    textAlign: 'center',
    maxHeight: 200,
    minHeight: 100,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    marginTop: 10,
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto',
    width: '100%',
    flex: 1,
    padding: '0px 23px',
    justifyContent: 'center',
    [theme.breakpoints.down(1024)]: {
      margin: 0,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    display: 'flex',
    alignSelf: 'center',
    fontSize: 32,
    fontWeight: 300,
    letterSpacing: '-0.23px',
    marginBottom: 40,
    textAlign: 'left',
    width: '100%',
  },
  linksContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0 0 30px',
    fontSize: theme.UserAuthDialog.footer.fontSize,

    '& a:link': {
      fontWeight: 'bold',
    },
  },
}))

const UserAuthDialog = (props) => {
  // logo and classNameHeader are optional - the orgaMAX login shows the brand logo top left;
  // icon is shown above the title, e.g. the tick of a success state
  const { children, title, footer, className, classNameTitle, classNameFormContainer, classNameHeader, logo, icon } = props
  const classes = useStyles()

  const containerClasses = `${classes.root} ${className || ''}`
  const linksContainer = `${classes.linksContainer} omo-footer`

  return (
    <section className={containerClasses}>
      <header className={clsx(classes.headerContainer, classNameHeader)}>
        {logo ? <SVGIcon height="32px" width="144px" svg={logo} /> : <SVGIcon height="48px" width="189px" svg={OMOLogo} />}
      </header>
      <div className={clsx(classes.formContainer, classNameFormContainer)}>
        <div className={classes.content}>
          {icon}
          <Title className={clsx(classes.title, classNameTitle)}><span dangerouslySetInnerHTML={{ __html: title }} /></Title>
          {children}
        </div>
      </div>
      <footer className={linksContainer}>
        {footer}
      </footer>
    </section>
  )
}

export default UserAuthDialog
